import { cloneObject } from 'utils';
import SearchConfig from '@sun-chemical/system-config/search-config';
import qs from 'qs';

export default {
  urlFilters(state) {
    const urlFilters = cloneObject(state.urlFilters);

    Object.keys(urlFilters).forEach((key) => {
      if (urlFilters[key] === '' || urlFilters[key] === 0) {
        delete urlFilters[key];
      }
    });

    return urlFilters;
  },
  activeSortOption(state, getters) {
    if (getters.urlFilters && typeof getters.urlFilters.sort === 'string') {
      const parts = getters.urlFilters.sort.split('.');

      return {
        field: parts[0],
        order: parts[1] ?? 'asc'
      };
    }

    return undefined;
  },
  filtersAsSearchCategory(state, getters) {
    if (getters.hasActiveFilters) {
      const filters = cloneObject(getters.urlFilters);
      delete filters.q;

      if (Object.keys(filters).length > 0) {
        return qs.stringify(filters, { arrayFormat: 'comma', encode: false });
      }
    }

    return false;
  },
  hasActiveFilters(state, getters) {
    if (getters.urlFilters && typeof getters.urlFilters === 'object') {
      const filterKeys = Object.keys(getters.urlFilters)
        .filter((key) => !['tab', 'sort'].includes(key));

      return filterKeys.length > 0;
    }

    return false;
  },
  aggregations(state) {
    return state.results.aggregations;
  },
  results(state) {
    return state.results;
  },
  resultsTotal(state, getters) {
    if (!getters.hasResults) return 0;

    return state.results.total;
  },
  hasResults(state) {
    return state.results && state.results.total && state.results.total > 0;
  },
  canLoadMore(state, getters) {
    if (!getters.hasResults) return false;

    return getters.results.hits.length < getters.resultsTotal;
  },
  searchTerm(state) {
    return typeof state.urlFilters[SearchConfig.getMap().search_term.param] !== 'undefined'
      ? state.urlFilters[SearchConfig.getMap().search_term.param]
      : '';
  },
  activeDropDownFilter(state) {
    return state.activeDropDownFilter;
  }
};
